import { useTranslation } from '@thoughtspot/i18n';
import { reportError } from '@thoughtspot/mfe-utilities';
import { MutedAlert } from '@thoughtspot/radiant-react/widgets/alert/muted/muted-alert';
import React from 'react';
import { Vertical } from '../../utils/layouts';
import styles from './generic-error-container.module.scss';
const GenericError = () => {
    const { t } = useTranslation();
    return (React.createElement(Vertical, { hAlignContent: "center", vAlignContent: "center", className: styles.genericErrorWrapper, grow: true },
        React.createElement(MutedAlert, { global: true, imageVisible: true, title: t('answerInitError.title'), description: t('answerInitError.detail'), primaryAction: {
                label: t('alertService.REPORT'),
                onClick: reportError,
            }, secondaryAction: {
                label: t('answerInitError.retry'),
                onClick: () => {
                    window.location.reload();
                },
            } })));
};
export { GenericError };
//# sourceMappingURL=generic-error.container.js.map